import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';

import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import useMobileLayout from 'Hooks/useMobileLayout';
import AccountSetupSection from '../../Components/AccountSetup/AccountSetupSection';
import SurveyFixedFooterActions from '../../../SurveyFixedFooterActions';
import { useSurveyStepContext } from '../../SurveyStepContext';

const styles = theme => ({
  root: {},
  footer: {},
  enableButton: {
    marginTop: theme.spacing(1),
  },
});

const AccountSetupTwoFactorAuthenticationLayout = ({
  classes,
}) => {
  const {
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  // Go to next survey step
  const {
    onClickNext,
    goToNextStep,
  } = useSurveyStepContext();

  const isMobile = useMobileLayout();

  return (
    <div className={classes.root}>
      {/* ---------- Section title / icon / message ---------- */}
      <AccountSetupSection
        title={'Two-Factor Authentication'}
        messages={[
          'When enabled, we will send you a secure SMS code that you will be required to enter each time you login.',
          'Adding two factor authentication will make your account more secure.',
        ]}
        showFacetIcon
      />

      {/* ---------- Footer (Navigator) ---------- */}
      <SurveyFixedFooterActions>
        {/* Do not Enable 2FA (Submits resource) */}
        <TextButton
          onClick={() => onClickNext(onSubmitMetaForm)}
          color={'primary'}
          weight={'bold'}
          fullWidth
          size={!isMobile ? 'lg' : 'md'}
          test={'do-not-enable-two-factor-auth-button'}
        >
          {'Don\'t enable'}
        </TextButton>

        {/* Enable 2FA (Fetch / goto next survey step) */}
        <RoundedButton
          className={classes.enableButton}
          onClick={goToNextStep}
          color={'primary'}
          variant={'contained'}
          disableElevation
          fullWidth
          test={'enable-two-factor-auth-button'}
        >
          {'Enable two-factor authentication'}
        </RoundedButton>
      </SurveyFixedFooterActions>
    </div>
  );
};

AccountSetupTwoFactorAuthenticationLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

AccountSetupTwoFactorAuthenticationLayout.defaultProps = {
};

export default withStyles(styles)(AccountSetupTwoFactorAuthenticationLayout);
